import { Component, createMemo, JSX, onMount, Show } from 'solid-js'

import { A, RouteSectionProps, useNavigate } from '@solidjs/router'
import { LoadingDots, setPopup } from 'components'
import {
    CorpsIcon,
    EditIcon,
    HandshakeIcon,
    InsuranceIcon,
    LogoutIcon,
    UserIcon,
    UsersIcon,
} from 'icons'
import { LOCAL_ECONOMIC_NUMBER, LOCAL_INSURER_PHONE } from 'store/labels'
import { logoutUser, self, userRole } from 'store/self'
import { extentionState } from './extentions/submitteds'
import { InsS } from './insurances'
import './style/panel.scss'
import { CorpInsS } from './users/corp/insurnaces'
import { cState, isAdmin } from './users/corp/shared'
import { CorpUsersS } from './users/corp/users'

export let DEFAULT_PHONE: undefined | string
export let DEFAULT_ECONOMIC_NUMBER: undefined | string

export const setDefaultPhone = (p: string) => (DEFAULT_PHONE = p)
export const set_def_economic_number = (p: string) =>
    (DEFAULT_ECONOMIC_NUMBER = p)

export let outletRef: HTMLElement
const Panel: Component<RouteSectionProps> = P => {
    const clicked = () => {
        if (!outletRef) return

        outletRef.scrollTo({ top: 0, behavior: 'smooth' })
    }

    onMount(() => {
        onMount(() => {
            let phone = localStorage.getItem(LOCAL_INSURER_PHONE)
            if (phone) setDefaultPhone(phone)

            let en = localStorage.getItem(LOCAL_ECONOMIC_NUMBER)
            if (en) set_def_economic_number(en)
        })
    })

    const isDisable = createMemo(() => {
        let corpEdit = cState.edit
        let corpInsShow = CorpInsS.add.show
        let corpUsersShow = CorpUsersS.add.show
        let insShow = InsS.add.show
        let extShow = extentionState.add.show

        return corpEdit || corpInsShow || corpUsersShow || insShow || extShow
    })

    return (
        <Show when={!self.loading} fallback={<LoadingUser />}>
            <Show when={self.user?.id} fallback={<GoLogin />}>
                <main class='panel-container'>
                    <Aside onClick={clicked} />

                    <section
                        class='outlet-container'
                        ref={e => (outletRef = e)}
                        data-lenis-prevent
                        classList={{ disable: isDisable() }}
                    >
                        {P.children}
                    </section>
                </main>
            </Show>
        </Show>
    )
}

interface AsideProps {
    onClick(): void
}
const Aside: Component<AsideProps> = P => {
    type secLinkT = {
        icon: JSX.Element
        holder: string
        link: string
        end?: boolean
        onClick(): void
    }
    const SecLink: Component<secLinkT> = P => {
        return (
            <A
                href={P.link}
                end={P.end || false}
                inactiveClass=''
                class='sec-link title_small'
                onclick={() => P.onClick()}
            >
                <div class='active-style'></div>

                {P.icon}
                <span>{P.holder}</span>
                <div />
            </A>
        )
    }

    return (
        <aside class='sidebar-container'>
            <div class='user-container'>
                <div class='user-name title'>
                    <Show when={self.user?.name} fallback={'بدون نام!'}>
                        {self.user!.name}
                    </Show>
                </div>
                <div class='user-role title_smaller'>
                    {self.user && userRole(self.user)}
                </div>
            </div>
            <div class='sec-links'>
                {/* <SecLink holder='داشبورد' end link='' icon={<HomeIcon />} /> */}
                <SecLink
                    onClick={P.onClick}
                    holder='اطلاعات من'
                    link='profile'
                    icon={<UserIcon />}
                />

                <Show when={isAdmin()}>
                    <SecLink
                        onClick={P.onClick}
                        holder='بیمه ها'
                        link='insurances'
                        icon={<InsuranceIcon />}
                    />
                    <SecLink
                        onClick={P.onClick}
                        holder='الحاقیه ها'
                        link='extentions'
                        icon={<EditIcon />}
                    />
                    <SecLink
                        onClick={P.onClick}
                        holder='شرکت ها'
                        link='corporations'
                        icon={<CorpsIcon />}
                        end
                    />
                    <SecLink
                        onClick={P.onClick}
                        holder='کاربران'
                        link='users'
                        icon={<UsersIcon />}
                    />
                    <SecLink
                        onClick={P.onClick}
                        holder='درخواست همکاری'
                        link='coop-requests'
                        icon={<HandshakeIcon />}
                    />
                </Show>

                <Show when={self.user?.staff_at}>
                    <SecLink
                        onClick={P.onClick}
                        holder='شرکت من'
                        link={`corporations/corp/${self.user?.staff_at}`}
                        icon={<CorpsIcon />}
                    />
                </Show>
            </div>
            <button
                class='logout title_small'
                onclick={() => {
                    setPopup({
                        class: 'logout',
                        show: true,
                        type: 'error',
                        Icon: LogoutIcon,
                        timer: 1,
                        title: 'خروج از حساب؟',
                        content:
                            'بعد از خروج از حساب نیاز به ورود دوباره دارید.',
                        onSubmit() {
                            logoutUser()
                        },
                    })
                }}
            >
                <div class='icon'>
                    <LogoutIcon />
                </div>
                خروج از حساب
                <div />
            </button>
        </aside>
    )
}

const GoLogin: Component = () => {
    let nav = useNavigate()
    onMount(() => {
        nav('/login')
    })
    return <></>
}

const LoadingUser: Component = () => {
    return (
        <div class='loading-user section_title'>
            <LoadingDots />
            درحال گرفتن اطلاعات از سرور
        </div>
    )
}

export default Panel
